module.exports = __webpack_public_path__ + "static/img/restaurant-main-img03.510ead3c.svg";